<template>
  <div class="content"  v-wechat-title="$store.state.region.re_name + '-语音导览'">
        <new-top :title="'语音导览'"></new-top>
    <div
    style="padding-top:44px"
      class=""
      v-if="voice.audio_srcs != null || voice.audio_content != null"
    >
      <img
        style="width: 100%"
        v-if="voice.VideoUrl != null"
        :src="voice.VideoUrl" />
      <span class="title">{{ voice.audioName }}</span>
      <div class="text">{{ voice.audio_content }}</div>
      <div
        class="btn"
        v-if="voice.audio_srcs != null || voice.audio_content != null"
      >
        <div class="music_rightss">
          <div
            class="music_btn"
            @click="playAudio1()"
            v-if="voice.audio_srcs != null"
          >
            <img
              v-show="!isShow1"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/zanting.png"/>
            <img
              v-show="isShow1"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/bofangs.png"
            />
            <div>中文</div>
          </div>
          <div
            class="music_btn"
            @click="playAudio3()"
            v-if="voice.en_audio != null"
          >
            <img
              v-show="!isShow3"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/zanting.png"/>
            <img
              v-show="isShow3"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/bofangs.png"
            />
            <div>EN</div>
          </div>
          <div
            class="music_btn"
            @click="playAudio2()"
            v-if="voice.audio_content != null"
          >
            <img
              v-show="!isShow2"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/zanting.png"
              mode=""
            />
            <img
              v-show="isShow2"
              src="http://yuyok.oss-cn-hangzhou.aliyuncs.com/storage/storage1/image/icon/bofangs.png"
              mode=""
            />
            <div>AI</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class=""
      v-else
      style="display: flex; justify-content: center; color: #acacac"
    >
      暂无数据
    </div>
    <audio :src="src" autoplay id="zhenren"></audio>
  </div>
</template>

<script>
import { audiodetail } from "@/api/travel";
import $ from "jquery";
import TtsRecorder from "@/assets/js/speechSynthesis/audio";
import newTop from "@/components/travel/newTop.vue";
const ttsRecorder = new TtsRecorder();
export default {
  data() {
    return {
      title: "语音导览",
      isShow1: false,
      isShow2: false,
      isShow3: false,
      voice: {},
      src: "",
      element: null,
      text: "",
    };
  },
  components:{
      newTop
  },
  methods: {
    playAudio1() {
      let flag = (this.isShow1 = !this.isShow1);
      this.isflaag();
      if (!flag) {
        this.element.pause();
        return;
      }
      this.src = this.voice.audio_srcs;
      this.isShow1 = flag
      this.element.play();
    },
    playAudio3() {
      let flag = (this.isShow3 = !this.isShow3);
      this.isflaag();
      if (!flag) {
        this.element.pause();
        return;
      }
      this.src = this.voice.en_audio;
      this.isShow3 = flag
      this.element.play();
    },
    playAudio2() {
      this.text = this.voice.audio_content;
      let flag = (this.isShow2 = !this.isShow2);
      this.isflaag();
      if (!flag) {
        return;
      }
      setTimeout(()=>{
        this.yuyin();
      },300)
      this.isShow2 = flag
    },
    isflaag() {
      if (this.element) {
        this.element.currentTime = 0;
        this.element.pause();
      }
      ttsRecorder.stop();
      this.isShow1 = false;
      this.isShow2 = false;
      this.isShow3 = false;
    },
    yuyin() {
      //要合成的文本
      ttsRecorder.setParams({
        text: this.text,
        //  voiceName: '',
        speed: 50,
        voice: 50,
      });
      ttsRecorder.start();
    },
  },
  beforeDestroy() {
    ttsRecorder.stop();
    this.element.pause();
  },
  created() {
    audiodetail(this.$route.params).then((res) => {
      this.voice = res.audits;
    });
    this.$nextTick(() => {
      let audios = $("#zhenren");
      this.element = audios[0];
    });
    this.isflaag();
  },
};
</script>

<style scoped>
.content{
    min-height: 100vh;
    background: #fff;
}
.text {
  padding: 0 16px;
  display: block;
  display: flex;
  padding-bottom: 100px;
}

.title {
  display: flex;
  justify-content: center;
  line-height: 80px;
  font-size: 20px;
  font-weight: bold;
}

.btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border-radius: 60px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  bottom: 20px;
}

.music_rightss {
  display: flex;
}
.music_btn {
  width: 80px;
  box-sizing: border-box;
  padding: 4px 6px;
  display: flex;
  margin: 4px 0;
  align-items: center;
  justify-content: center;
  background: #e95b2d;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  margin-left: 4px;
}

.music_btn img {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
</style>
